<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>版本管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="search-box">
      <div class="item">
        商品ID：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.Id"
        ></el-input>
      </div>
      <div class="item">
        收款账号：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.BeneficiaryAccountNumber"
        >
        </el-input>
      </div>
      <div class="item">
        收款姓名：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.BeneficiaryAccountName"
        >
        </el-input>
      </div>
      <div class="item">
        角色名：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.PlayerRoleName"
        ></el-input>
      </div>
      <div class="item">
        分区名称：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.PartitionName"
        ></el-input>
      </div>
      <div class="item">
        订单号：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.OrderNumber"
        ></el-input>
      </div>
      <div class="item">
        类型：
      </div>
      <div class="item w1">
        <el-select
          placeholder="请选择"
          size="small"
          v-model="form.PaidOrderType"
        >
          <el-option :value="3" label="全部"> </el-option>
          <el-option :value="2" label="平台出款"> </el-option>
          <el-option :value="0" label="手动打款"> </el-option>
          <el-option :value="1" label="自有账户"> </el-option>
        </el-select>
      </div>
    </div>
    <div class="search-box">
      <div class="item">
        起止时间：
      </div>
      <div class="item input">
        <el-date-picker
          type="date"
          placeholder="开始时间"
          size="small"
          value-format="yyyy-MM-dd"
          v-model="form.StartTime"
        >
        </el-date-picker>
      </div>
      <div class="item input">
        <el-date-picker
          type="date"
          placeholder="结束时间"
          size="small"
          value-format="yyyy-MM-dd"
          v-model="form.EndTime"
        >
        </el-date-picker>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="tips">
      商户累计总额<font color="#ff0000">{{ view.accruingAmounts }}</font
      >元, 秒提总额<font color="#ff0000">{{ view.secondSpeed }}</font
      >元, 今日总额<font color="#ff0000">{{ view.todayTotal }}</font
      >元
    </div>
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column property="orderNumber" label="订单号" align="center">
      </el-table-column>
      <el-table-column property="partitionName" label="分区名称" align="center">
      </el-table-column>
      <el-table-column
        property="playerRoleName"
        label="角色名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="applyAmount"
        label="申请金额(元)"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="realAmount"
        label="出款金额(元)"
        align="center"
      >
      </el-table-column>
      <el-table-column property="paidOrderType" label="类型" align="center">
      </el-table-column>
      <el-table-column
        property="beneficiaryAccountNumber"
        label="收款账号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="beneficiaryAccountName"
        label="收款姓名"
        align="center"
      >
      </el-table-column>
      <el-table-column property="createTime" label="申请时间" align="center">
      </el-table-column>
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small">修改</el-button>
          <el-button type="text" size="small">退款</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <!-- 自由账户配置 -->
    <el-dialog title="自由账户配置" :visible.sync="dialogConfig">
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改前" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改后" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改时间" align="center">
        </el-table-column>
        <el-table-column property="name" label="操作人" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      dialogConfig: false,
      tableData: [],
      form: {
        Id: '',
        ApplicationUserId: '',
        BeneficiaryAccountNumber: '',
        BeneficiaryAccountName: '',
        PlayerRoleName: '',
        PartitionName: '',
        OrderNumber: '',
        PaidOrderType: '',
        StartTime: '',
        EndTime: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      },
      view: {}
    };
  },
  created() {
    this.getLists();
    this.getView();
  },
  methods: {
    async getView() {
      let header = await mgr();
      api
        .get('/api/Paid/GetCompletedOrderOverview', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.view = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async getLists() {
      let header = await mgr();
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      api
        .get('/api/Paid/CompletedPaidOrderList', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    search() {
      this.tableData = [];
      this.form.PageNumber = 1;
      this.getLists();
    },
    reset() {
      this.tableData = [];
      this.form = {
        Id: '',
        ApplicationUserId: '',
        BeneficiaryAccountNumber: '',
        BeneficiaryAccountName: '',
        PlayerRoleName: '',
        PartitionName: '',
        OrderNumber: '',
        PaidOrderType: '',
        StartTime: '',
        EndTime: '',
        PageNumber: 1,
        PageSize: 0,
        total: 0
      };
      this.getLists();
    }
  }
};
</script>
<style></style>
<style scoped>
.gs_container {
  background-color: #fff;
}
</style>
